import React, { Component } from 'react'

import ReporteEmbarqueSector12Linea5 from '../../tablasReporteParaEmbarque/reporteEmbarqueSector12/reporteEmbarqueSector12Linea5/containers/ReporteEmbarqueSector12Linea5'
import FiltroCerealCerealVariedadYEtiqueta from '../../shared/filtroCerealCerealVariedadYEtiqueta/containers/FiltroCerealCerealVariedadYEtiqueta'
import { Container, Row, Col } from 'react-bootstrap'
import ReporteEmbarqueSector12Linea6 from '../../tablasReporteParaEmbarque/reporteEmbarqueSector12/reporteEmbarqueSector12Linea6/containers/ReporteEmbarqueSector12Linea6'
import ReporteEmbarqueSector12Linea7 from '../../tablasReporteParaEmbarque/reporteEmbarqueSector12/reporteEmbarqueSector12Linea7/containers/ReporteEmbarqueSector12Linea7'
import ReporteEmbarqueSector3Linea6 from '../../tablasReporteParaEmbarque/reporteEmbarqueSector3/reporteEmbarqueSector3Linea6/containers/ReporteEmbarqueSector3Linea6'
import ReporteEmbarqueSector3Linea7 from '../../tablasReporteParaEmbarque/reporteEmbarqueSector3/reporteEmbarqueSector3Linea7/containers/ReporteEmbarqueSector3Linea7'
import ReporteEmbarqueSector3Linea5 from '../../tablasReporteParaEmbarque/reporteEmbarqueSector3/reporteEmbarqueSector3Linea5/containers/ReporteEmbarqueSector3Linea5'
import ReporteEmbarqueSector4 from '../../tablasReporteParaEmbarque/reporteEmbarqueSector4/containers/ReporteEmbarqueSector4'
import ReporteEmbarqueSector5 from '../../tablasReporteParaEmbarque/reporteEmbarqueSector5/containers/ReporteEmbarqueSector5'

export class ReporteParaEmbarqueView extends Component {
  render () {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <FiltroCerealCerealVariedadYEtiqueta />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ReporteEmbarqueSector12Linea5 />
            <ReporteEmbarqueSector12Linea6 />
            <ReporteEmbarqueSector12Linea7 />
            <ReporteEmbarqueSector3Linea5 />
            <ReporteEmbarqueSector3Linea6 />
            <ReporteEmbarqueSector3Linea7 />
            <ReporteEmbarqueSector4 />
            <ReporteEmbarqueSector5 />
          </Col>
        </Row>
      </Container>
    )
  }
}
